import { GET_RATECALCULATION } from "resources/actionTypes";

const intialStateRateCalculation = {
  userRateCalculation: '',
  loading: false,
  error: null,
};

export function userRateCalculation(state = intialStateRateCalculation, action) {
  switch (action.type) {
    case GET_RATECALCULATION.GET_RATECALCULATION_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_RATECALCULATION.GET_RATECALCULATION_SUCCESS:
      return {
        ...state,
        loading: false,
        userRateCalculation: action.userRateCalculation,
      }
    case GET_RATECALCULATION.GET_RATECALCULATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}